import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import reducers from './reducers';
import api from './middlewares/api';
import { verifyAuth } from './modules/auth/actions';
import { enableMessaging } from './actions';

export default initialState => {
  const composeEnhancers =
    (process.env.NODE_ENV !== 'production' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  const store = createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(thunk, api))
  );

  store.dispatch(verifyAuth(function () {
    store.dispatch(enableMessaging());
  }));
  
  return store;
};



// WEBPACK FOOTER //
// ./src/configureStore.js